import { render, staticRenderFns } from "./CandidateEvents.vue?vue&type=template&id=3607d40f&"
import script from "./CandidateEvents.vue?vue&type=script&lang=js&"
export * from "./CandidateEvents.vue?vue&type=script&lang=js&"
import style0 from "./CandidateEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports